import { TransactionCompareWindow } from "@/portal/modal/TransactionCompareWindow";

export class UtilController {
    private $element: JQuery;

    constructor(element: JQuery) {
        this.$element = element;

        this.$element.find("#trxcompareportlet .btn").click((e) => {
            e.preventDefault();

            new TransactionCompareWindow().show();
        });
    }
}
